import {Component, EventEmitter, ViewEncapsulation} from "@angular/core";

@Component({
    selector     : '.drop-down-demo',
    encapsulation: ViewEncapsulation.None,
    template: `<h4>Drop Down (Select)</h4>
<h5>Example</h5>
<div class="card card-body bg-light form-group">
    <form #testForm="ngForm" novalidate>
        <check-box [(ngModel)]="model.required" name="required" label="Is Required" labelPlacement="after"></check-box>
        <check-box [(ngModel)]="model.isMultiple" name="isMultiple" label="Is Multiple"
                   labelPlacement="after"></check-box>
        <text-box name="icon" label="Icon" [(ngModel)]="model.icon"></text-box>
        <drop-down
                [options]="model.options"
                [selectBy]="'id'"
                class="full-width"
                name="testOptionList"
                label="Test Option List"
                [icon]="model.icon"
                [required]="model.required"
                [(ngModel)]="model.selected"
                [isMultiple]="model.isMultiple"
                [placeholder]="'Select One...'">
            <ng-template let-item>
                {{item.id}} - {{ item.text }}
            </ng-template>
        </drop-down>
        <submit-button label="Submit" [formGroup]="testForm.form"></submit-button>
    </form>
</div>
<h5>Data Model</h5>
<pre class="card card-body bg-light">{{ model | json }}</pre>
<h5>Markup</h5>
<pre class="card card-body bg-light">{{ markup }}</pre>
`
})
export class DropDownDemoComponent {
    model = {
        isMultiple: false,
        icon      : '',
        required  : false,
        selected  : null,
        options   : [
            {id: 1, text: 'Label 1'},
            {id: 2, text: 'Label 2'},
            {id: 3, text: 'Label 3'}
        ]
    };

    markup = `
<drop-down
        [options]="model.options"
        [selectBy]="'id'"
        class="full-width"
        name="testOptionList"
        label="Test Option List"
        [required]="model.required"
        [(ngModel)]="model.selected"
        [isMultiple]="model.isMultiple"
        [placeholder]="'Select One...'">
    <ng-template let-item>
        {{item.id}} - {{ item.text }}
    </ng-template>
</drop-down>
    `;


}
